/**
Project: Voice Panel (c)
Title: Page Loader
Description: Component for displaying page loading spinner
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import { Flex, Loader } from "@fluentui/react-northstar";

class PageLoader extends Component {
  render() {
    if (this.props.status) {
      // data load status is true
      return this.props.children;
    } else {
      // data load status is false
      let size = "medium";
      if (this.props.size) {
        size = this.props.size;
      }
      let label = null;
      if (this.props.label) {
        label = this.props.label;
      }
      let labelPosition = null;
      if (this.props.label) {
        labelPosition = this.props.labelPosition;
      }
      let type = "inline";
      if (this.props.type) {
        type = this.props.type;
      }
      let typeClassName = "";
      if (type === "inline") {
        typeClassName = "page-loader-wrapper-inline";
      } else if (type === "full") {
        typeClassName = "page-loader-wrapper-full";
      } else if (type === "center") {
        typeClassName = "page-loader-wrapper-center";
      } else if (type === "full-center") {
        typeClassName = "page-loader-wrapper-full-center";
      }

      return (
        <Flex>
          <Flex className={typeClassName}>
            <Loader size={size} label={label} labelPosition={labelPosition} />
          </Flex>
        </Flex>
      );
    }
  }
}

export default PageLoader;
